const BLUR_UP_SELECTOR = '.blur-up';

function initializeBlurUp(container) {
  if (!(container instanceof Element) || container.dataset.blurUpInitialized === 'true') return;

  const image = container.querySelector(':scope > img');
  if (!image) return;

  container.dataset.blurUpInitialized = 'true';

  if (image.complete && image.naturalWidth > 0) {
    container.classList.add('is-blur-up-ready');
    return;
  }

  container.classList.add('is-blur-up-loading');

  const revealImage = () => {
    container.classList.remove('is-blur-up-loading');
    container.classList.add('is-blur-up-ready');
  };

  image.addEventListener('load', revealImage, { once: true });
  image.addEventListener('error', revealImage, { once: true });
}

function initializeBlurUps(root = document) {
  if (root instanceof Element && root.matches(BLUR_UP_SELECTOR)) initializeBlurUp(root);
  root.querySelectorAll?.(BLUR_UP_SELECTOR).forEach(initializeBlurUp);
}

initializeBlurUps();

new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => initializeBlurUps(node));
  });
}).observe(document.documentElement, { childList: true, subtree: true });
